// https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
export const isoCountryCode2 = {
    USA: 'US',
    AUSTRALIA: 'AU',
    PUERTO_RICO: 'PR',
};

// https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3
export const isoCountryCode3 = {
    USA: 'USA',
    AUSTRALIA: 'AUS',
    PUERTO_RICO: 'PRI',
};
